import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import GroupIcon from "@mui/icons-material/Group";
import DescriptionIcon from "@mui/icons-material/Description";
import HomeIcon from "@mui/icons-material/Home";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JoinUs from "./Pages/JoinUs";
import Announcements from "./Pages/adverts";
import { IApplicationLanguage, ILanguage } from "./Pages/types";
import apiRequest from "./Utils/apiRequest";
import ApplicationForm from "./Pages/applicationForm";
import JobApplicationModal from "./Pages/applicationDetail";
import ApplicationFormInternalAnnoucment from "./Pages/applicationFormInternalAnnoucment";
import InternalAdvert from "./Pages/internalAdverts";
import ApplicationFormInternalAdvertOwnApp from "./Pages/applicationFormInternalAdvertOwnApp";
interface IAppResource {
  path: string | undefined;
  component: JSX.Element | undefined;
  authRequired: boolean;
  renderSidebar: boolean;
  permission?: string | undefined;
  label?: string;
  icon?: JSX.Element;
  subMenu?: IAppResource[];
}

export const useAppResources = () => {
  const { t } = useTranslation();

  const appResources = [
    {
      label: "",
      path: "/",
      component: <Navigate to="/bizekatil" />,
      renderSidebar: false,
      authRequired: true,
    },
    {
      label: t("İlanlar"),
      path: "ilanlar",
      component: <Announcements />,
      icon: <HomeIcon />,
      renderSidebar: false,
      authRequired: true,
    },
    {
      label: t("Başvuru Detay"),
      path: "basvurudetay/:id",
      component: <JobApplicationModal />,
      icon: <HomeIcon />,
      renderSidebar: false,
      authRequired: true,
    },
    {
      label: t("Bize Katıl"),
      path: "bizekatil",
      component: <JoinUs />,
      icon: <GroupIcon />,
      renderSidebar: true,
      authRequired: true,
    },
    {
      label: t("Başvuru Formu"),
      path: "basvuruformu/:id",
      component: <ApplicationForm />,
      icon: <DescriptionIcon />,
      renderSidebar: true,
      authRequired: true,
    },
    {
      label: t("Başvuru İç İlan"),
      path: "adverts/:advertId/organization/:organizationId",
      icon: <DescriptionIcon />,
      component: <InternalAdvert />,
      renderSidebar: false,
      authRequired: true,
    },
    {
      label: t("Başvuru Formu İç İlan"),
      path: "applicationFormInternalAnnoucment/:advertId/organization/:organizationId",
      icon: <DescriptionIcon />,
      component: <ApplicationFormInternalAnnoucment />,
      renderSidebar: false,
      authRequired: true,
    },
    {
      label: t("Başvuru Formu İç İlan"),
      path: "applicationFormOwnInternalAnnoucment/:advertId/organization/:organizationId",
      icon: <DescriptionIcon />,
      component: <ApplicationFormInternalAdvertOwnApp />,
      renderSidebar: false,
      authRequired: true,
    },
  ];

  return appResources;
};

export const getToken = (): string | null => localStorage.getItem("token");

export const getOptions = (): RequestInit => {
  return {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};

export const postOptions = (body: object): RequestInit => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(body),
  };
};

export const putOptions = (body: object): RequestInit => {
  return {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(body),
  };
};

type Environment = "development" | "production";
const env = process.env.NODE_ENV as Environment;
export const apiUrl =
  env === "development"
    ? process.env.REACT_APP_API_URL_DEVELOPMENT!
    : process.env.REACT_APP_API_URL_PRODUCTION!;

const LanguageContext = createContext<{
  applicationLanguageListData: IApplicationLanguage[];
  isLanguageLoaded: boolean;
}>({ applicationLanguageListData: [], isLanguageLoaded: false });

export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }: PropsWithChildren<{}>) => {
  const [applicationLanguageListData, setApplicationLanguageListData] =
    useState<IApplicationLanguage[]>([]);
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);
  const [applicationLanguage, setApplicationLanguage] = useState<ILanguage>({
    LanguageId: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      const url = `${apiUrl}ApplicationLanguage/getList`;
      try {
        const response = await apiRequest("GET", url, "");
        setApplicationLanguageListData(response?.data);
        if (localStorage.getItem("language") === null) {
          const newLanguage = {
            ...applicationLanguage,
            LanguageId: response?.data.find((x: any) => x.isBase)
              ?.applicationLanguageId,
          };
          const base64ApplicationLanguage = btoa(JSON.stringify(newLanguage));
          localStorage.setItem("language", base64ApplicationLanguage);
          setApplicationLanguage(newLanguage);
        }
        if (localStorage.getItem("languageCode") === null) {
          localStorage.setItem(
            "languageCode",
            response?.data.find((x: any) => x.isBase)?.languageCode || "tr"
          );
        }
        setIsLanguageLoaded(true);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  if (!isLanguageLoaded) {
    return <div></div>;
  }

  return (
    <LanguageContext.Provider
      value={{ applicationLanguageListData, isLanguageLoaded }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
